<template src="./surveysEditModal.html"></template>

<script>
import dmModalMixin from '../../../../dmFramework/dmJS/dmModalMixin';
import surveysEndpoints from '../surveys.endpoints';

export default {
    name: 'surveys-edit-modal',
    mixins: [dmModalMixin],
    data() {
        return {
            dto: {},
            dropdownFields: {
                text: 'Text',
                value: 'Value',
            },
        };
    },
    computed: {
        lblTitle() {
            return this.modalData.mode === 'edit' ? 'Edit Survey' : 'Add Survey';
        },
    },
    methods: {
        btnSaveOnClick() {
            if (this.modalData.mode === 'add') {
                surveysEndpoints.create(this.dto)
                    .then(() => {
                        this.successClose(this.dto);
                    });
            } else if (this.modalData.mode === 'edit') {
                surveysEndpoints.update(this.dto)
                    .then(() => {
                        this.successClose(this.dto);
                    });
            }
        },
        btnCancelOnClick() {
            this.closeModal();
        },
    },
    created() {
        this.dto = DMUtils.copy(this.modalData.dto);
    },
};
</script>
